import React, { Component } from 'react'
import AWSAPI from '../../../common/AWSAPI'
import Window from '../../../common/Window'
import Loading from '../../../common/component/Loading'
import Config from '../../../Config'

class SurveyBigQuestionEdit extends Component {
  constructor (props) {
    super(props)
    const initialState = this.getInitialState()
    this.state = initialState
    this.apiUrl = Config.adminApiUrl.surveyQuestionSetting
    this.userRole = 'admin'
  }
  getInitialState () {
    return {
      isLoaded: false,
      isNew: true,
      id: null,
      bigQuestions: {},
      mediumQuestions: {},
      smallQuestions: {},
      maxId: null,
      maxSort: null,
    }
  }
  componentDidMount() {
    const { id } = this.props.match.params
    this.loadServey(id)
  }
  loadServey(id) {
    const onSuccess = (res) => {
      // APIから取得したデータをstateに反映
      const surveyData = res.body.data
      this.setState({
        bigQuestions: surveyData.bigQuestions[0],
        mediumQuestions: surveyData.mediumQuestions[0],
        smallQuestions: surveyData.smallQuestions[0],
        maxId: surveyData.maxId,
        maxSort: surveyData.maxSort,
        isNew: id ? false : true,
        isLoaded: true,
      })
    }
    const params = {
      command: 'getBigDetail',
      surveyValue: { id: id },
    }
    AWSAPI.apiPost(this.userRole, this.apiUrl, params, onSuccess)
  }
  saveServey () {
    const {params} = this.props.match
    const id = params.id
    const servey = this.state
    if (!servey.bigQuestions.setsumon_title) {
      Window.alert('大設問タイトルは必須です')
      return false
    }
    if (!servey.bigQuestions.setsumon_type) {
      Window.alert('大設問タイプは必須です')
      return false
    }
    if (id && !servey.bigQuestions.setsumon_sort) {
      Window.alert('ソート順は必須です')
      return false
    }

    let updateOrInsert
    if (id) { // 更新
      updateOrInsert = (oldSurveyValue) => {
        const setsumonType = Number(servey.bigQuestions.setsumon_type || 0);
        const result = {
          id: servey.bigQuestions.id,
          setsumon_title: servey.bigQuestions.setsumon_title,
          setsumon_comment: servey.bigQuestions.setsumon_comment,
          setsumon_type: setsumonType,
          setsumon_sort: servey.bigQuestions.setsumon_sort,
          createDateTime: servey.bigQuestions.createDateTime,
          lastUpdateDateTime: servey.bigQuestions.lastUpdateDateTime,
          isNew: false
        }
        return result
      }
    } else { // 新規登録
      updateOrInsert = (oldSurveyValue) => {
        const newId = Number(servey.maxId || 0) + 1;
        const setsumonType = Number(servey.bigQuestions.setsumon_type || 0);
        const newSortId = Number(servey.maxSort || 0) + 1;
        const result = {
          id: newId,
          setsumon_title: servey.bigQuestions.setsumon_title,
          setsumon_comment: servey.bigQuestions.setsumon_comment,
          setsumon_type: setsumonType,
          createDateTime: servey.bigQuestions.createDateTime,
          lastUpdateDateTime: servey.bigQuestions.lastUpdateDateTime,
          setsumon_sort: newSortId,
          isNew: true,
        }
        return result
      }
    }
    const onSuccessToGet = (res) => {
      const surveyValue = updateOrInsert(res.body)
      let paramsToSet = [];
      if(surveyValue.isNew === true) {
        paramsToSet = {
          command: 'bigAdd',
          surveyValue: surveyValue
        }
      } else {
        paramsToSet = {
          command: 'bigSet',
          surveyValue: surveyValue
        }
      }
      const onSuccessToPost = (res) => {
        Window.alert('保存しました', () => {
          this.props.history.push('/admin/survey_bigquestion')
          Window.closeDialog()
        })
      }
      AWSAPI.apiPost(this.userRole, this.apiUrl, paramsToSet, onSuccessToPost)
    }
    const paramsToGet = {
      command: 'get'
    }
    AWSAPI.apiPost(this.userRole, this.apiUrl, paramsToGet, onSuccessToGet)
  }
  delServey () {
    const servey = this.state
    const paramsToSet = {
      command: 'bigDel',
      surveyValue: servey.bigQuestions
    }
    const onSuccessToPost = (res) => {
      Window.alert('削除しました', () => {
        this.props.history.push('/admin/survey_bigquestion')
        Window.closeDialog()
      })
    }
    AWSAPI.apiPost(this.userRole, this.apiUrl, paramsToSet, onSuccessToPost)
  }
  onPageMenuClicked (name) {
    switch (name) {
      case 'back':
        if(this.state.isNew) {
          this.props.history.push('/admin/survey_bigquestion')
        } else {
          this.props.history.push(`/admin/survey_mediumquestion/${this.state.bigQuestions.id}`)
        }
        break
      case 'delete':
        Window.confirm('本当に削除処理を実行しますか?', () => {
          this.delServey()
        })
        break
      default:
        break
    }
  }
  uuid () {
    let uuid = ''
    let i
    let random
    for (i = 0; i < 32; i++) {
      random = Math.random() * 16 | 0

      if (i === 8 || i === 12 || i === 16 || i === 20) {
        uuid += '-'
      }
      uuid += (i === 12 ? 4 : (i === 16 ? ((random & 3) | 8) : random)).toString(16)
    }
    return uuid
  }
  renderSurveyDetail(state) {
    // stateからsurveyを展開
    const survey = state || { bigQuestions: {} };

    // bigQuestionsのデフォルト値を設定
    const bigQuestions = survey.bigQuestions || {};
    const setsumonTitle = bigQuestions.setsumon_title || '';
    const setsumonComment = bigQuestions.setsumon_comment || '';
    const setsumonType = bigQuestions.setsumon_type || '';
    const setsumonSort = bigQuestions.setsumon_sort || '';

    // 入力変更時の処理
    const changed = (name, e) => {
      const value = e.target.type === 'radio' ? e.target.value === 'true' : e.target.value;
      const [parentKey, childKey] = name.split('.');

      // ネストされたstateを更新
      this.setState(prevState => ({
        [parentKey]: {
          ...prevState[parentKey],
          [childKey]: value,
        },
      }));
    };

    // 新規登録/変更のタイトル設定
    const title = state && state.isNew ? '新規登録' : '変更'
    let setsumonTypeOptions
    if(state && state.isNew) {
      setsumonTypeOptions = [
        { value: '', label: '選択してください' },
        { value: 2, label: '質問事項' },
      ]
    } else {
      setsumonTypeOptions = [
        { value: '', label: '選択してください' },
        { value: 1, label: '回答会社連絡先等' },
        { value: 2, label: '質問事項' },
      ]
    }

    return (
      <fieldset>
        <legend>アンケート大設問情報 - {title}</legend>
        <br />
        <div className="control-group row">
          <label className="span3">
            大設問タイトル <span className="required">*</span>
          </label>
          <div className="span8">
            <input type="text" className="span8" value={setsumonTitle} onChange={e => changed('bigQuestions.setsumon_title', e)}/>
          </div>
        </div>
        <div className="control-group row">
          <label className="span3">
            大設問コメント
          </label>
          <div className="span10">
            <textarea name="setsumonComment" className="span10" value={setsumonComment} onChange={e => changed('bigQuestions.setsumon_comment', e)}/>
          </div>
        </div>
        <div className="control-group row">
          <label className="span3">
            大設問タイプ <span className="required">*</span>
          </label>
          <div className="span10">
            <select className="span4" value={setsumonType} onChange={(e) => changed('bigQuestions.setsumon_type', e)}>
              {setsumonTypeOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>
        {!state.isNew && (
          <div className="control-group row">
            <label className="span3">
              ソート順 <span className="required">*</span>
            </label>
            <div className="span1">
              <span>{setsumonSort}</span>
            </div>
          </div>
        )}
      </fieldset>
    );
  }
  onFormButtonClicked (name, e) {
    e.preventDefault()
    switch (name) {
      case 'save':
        this.saveServey()
        break
      case 'cancel':
        if(this.state.isNew) {
          this.props.history.push(`/admin/survey_bigquestion`)
        } else {
          this.props.history.push(`/admin/survey_mediumquestion/${this.state.bigQuestions.id}`)
        }
        break
      default:
        break
    }
  }
  render () {
    if (!this.state.isLoaded) {
      return <Loading />
    }
    const surveyDetail = this.renderSurveyDetail(this.state)
    const title = this.state.isNew ? '新規登録' : '変更'
    return (
      <div>
        <section className='nav-page'>
          <div className='container'>
            <div className='row'>
              <div className='span7'>
                <header className='page-header'>
                  <h3>アンケート情報 - {title}<br /><small>こちらでアンケート情報を{title}できます。</small></h3>
                </header>
              </div>
              <div className='span9'>
                <ul className='nav nav-pills'>
                  {this.state.bigQuestions && this.state.bigQuestions.createDateTime && (
                    <li className='kw-btn-area'><button rel='tooltip' data-placement='left' title='削除' className='text-center kw-btn-danger' onClick={(e) => this.onPageMenuClicked('delete')}><i className='icon-remove icon-large' /><span>削除</span></button></li>
                  )}
                  <li className='kw-btn-area'><button rel='tooltip' data-placement='left' title='戻る' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('back')}><i className='icon-arrow-left icon-large' /><span>戻る</span></button></li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className='page container'>
          <form className='form-horizontal' method='post'>
            <div className='container'>
              <div className='kw-ic-info-regist-area span16'>
                <div className='alert alert-block alert-info'>
                  <p>必要な情報を入力して最後に「保存」ボタンを押してください。「<span className='required'>*</span>」マークは必須項目です。</p>
                </div>
                {surveyDetail}
                <footer className='form-actions' id='submit-actions'>
                  <button className='btn btn-primary' onClick={(e) => this.onFormButtonClicked('save', e)} >保存</button>
                  <button className='btn btn-default' onClick={(e) => this.onFormButtonClicked('cancel', e)}>キャンセル</button>
                </footer>
              </div>
            </div>
          </form>
        </section>
      </div>
    )
  }
}

export default SurveyBigQuestionEdit



// WEBPACK FOOTER //
// ./src/admin/pages/secure/SurveyBigQuestionEdit.js